const validateVideoFile = (fileExt) => {
  return ['webm', 'mp4'].includes(fileExt);
};

export default validateVideoFile;
